import { oneApi } from 'config/api'
import { resourceLocationMap, resourceLocationSaMap } from 'common/map'

export default {
  data() {
    return {
      bannerList: [],
      current: 0,
    }
  },
  computed: {
    showBanner() {
      return this.bannerList.length > 0
    },
  },
  mounted() {
    this.queryBannerData()
  },
  methods: {
    /**
     * 获取Banner数据
     */
    async queryBannerData() {
      const locationKey = resourceLocationMap.get('shop-list')
      const params = [{
        locationKey,
      }]
      const res = await this.$axios.post(oneApi.getCoursesBannerList, params, { rewritePostBody: true })
      const { code, data = [] } = res
      if (code !== 0) {
        return
      }
      const bannerConfig = data.length ? data[0] : {}
      const resources = bannerConfig.resources || []
      this.bannerList = resources
    },

    /**
     * Banner切换事件
     * @param {Number} index Banner索引
     */
    onChange(index) {
      this.current = index;
      this.handleShow(this.bannerList[index])
    },

    /**
     * 神策埋点-资源位曝光事件
     * @param {Object} banner Banner数据对象
     */
    handleShow(banner) {
      this.Sensors.track('ad_show', {
        ad_name: resourceLocationSaMap.get('shop-list'),
        ad_id: banner.resId,
      })
    },

    /**
     * 神策埋点-资源位点击事件
     * @param {Object} banner Banner数据对象
     */
    handleClick(banner) {
      this.Sensors.track('ad_click', {
        ad_name: resourceLocationSaMap.get('shop-list'),
        ad_id: banner.resId,
      })
    },
  },
}
